import React, { Component } from "react";
import Common from '../shared/common';
import { withRouter } from '../shared/hoc/withRouter';
import { FormattedMessage } from "react-intl";
import moment from 'moment';
import { SelectBox } from 'devextreme-react';
import * as actionCrud from '../crud/action.crud';
import { withSnackbar } from 'notistack';
import { injectIntl } from "react-intl";
import MenuItemsHelper from "../store/helpers/MenuItemsHelper";
import SystemHelper from "../shared/systemHelper";
import { completeActionConfirmationDialog } from "../pages/admin/Contracts/Contract/ContractActions";


const spanStyle = {
  whiteSpace: 'normal',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  paddingBottom: 0
};

const spanStyleViewRegister = {
  whiteSpace: 'normal',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  paddingBottom: 0,
  fontWeight: 400
};


function calculateChangeRate(numerator, denominator) {
  if ((denominator === 0 || denominator === null) && (numerator > 0)) {
    return '100%';
  } else if (numerator === null || numerator === 0 || denominator === null || denominator === 0) {
    return '0%';
  } else {
    const changeRate = (((numerator) + 0) / (denominator + 0)) * 100;
    return Common.FormatNum(changeRate) + '%'
  }
}

const dummyActions = {
  items: [
    {
      actionid: 1,
      duedate: new Date(),
      actiontype: "PAY_DUE",
      RAGColor: 1,
      groupcategory: 1,
    },
    {
      actionid: 2,
      duedate: moment().add(1, "days")._d,
      actiontype: "PAY_LESS",
      RAGColor: 2,
      groupcategory: 1,
    },
    {
      actionid: 3,
      duedate: moment().add(3, "days")._d,
      actiontype: "INVOICE_REQUIRED",
      RAGColor: 2,
      groupcategory: 1,
    },
    {
      actionid: 4,
      duedate: moment().add(5, "days")._d,
      actiontype: "FINAL_DFP",
      RAGColor: 2,
      groupcategory: 1,
    },
    {
      actionid: 5,
      duedate: moment().add(7, "days")._d,
      actiontype: "PAY_ASSESS",
      RAGColor: 2,
      groupcategory: 1,
    },
    {
      actionid: 6,
      duedate: moment().add(10, "days")._d,
      actiontype: "WF_20",
      RAGColor: 3,
      groupcategory: 3,
      resolvingworkflowid: 20
    },
    {
      actionid: 7,
      duedate: moment().add(15, "days")._d,
      actiontype: "WF_21",
      RAGColor: 3,
      groupcategory: 3,
      resolvingworkflowid: 21
    }
  ]
};

class ContractNextPayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actions: props.contract.contractid === 0 ? dummyActions : { items: [] },
    }
  }

  componentDidMount() {
    this.setNewState();
  }


  setNewState = async () => {
    const newState = await this.getState();
    this.setState({ ...newState });
  }
  getState = async () => {
    try {
      if (this.props.contract.contractid === 0) {
        //   //DUMMY CONTRACT
        return dummyActions;
      }
      else {
        const { data: nextPaymentActionSummary } = await actionCrud.getNextPaymentActionsSummary(this.props.contract.contractid);
        const formattedActions = MenuItemsHelper.getContractManualActions(nextPaymentActionSummary, this.props.contractTemplate)
        // if (this.props.contract.contractid === 0) {
        //   //DUMMY CONTRACT
        return {
          actions: formattedActions
        };
      }

    }
    catch (err) {
      this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
    }
  };

  getDate = (actionItem) => {
    const { resources: globalResources } = this.props.contractTemplate;
    const formattedDate = moment(actionItem.duedate).format('L').replace(/\//g, '.'); // Handle empty date
    const badgeColor = MenuItemsHelper.getBadgeColorForRAGColor(actionItem.RAGColor, "bootstrap");
    let label = actionItem.actiontype;
    let onClickFunc = null;
    if (actionItem.groupcategory === 3 && actionItem.resolvingworkflowid) {
      let workflow = this.props.contractTemplate.workflowsQA[actionItem.resolvingworkflowid];
      label = workflow?.pageTitle;
      if (workflow?.userFilters?.mainNotice?.createAllowed) {
        onClickFunc = () => { this.props.navigate(workflow.paths.createPath); };
      }
      else if (workflow && (workflow.id === 20 || workflow.id === 21)) {
        //HANDLE PAYMENT BATCH EXCEPTION
        //IF THERE IS NO ACCESS TO PAYMENT WF, IT MAYBE BATCH PAYMENT WF, CHECK BATCH EQUIVELENT
        let pointToPatchWorklowID = workflow.id === 20 ? 78 : 79;
        workflow = this.props.contractTemplate.workflowsQA[pointToPatchWorklowID];
        if (workflow?.userFilters?.mainNotice?.createAllowed) {
          onClickFunc = () => { this.props.navigate(workflow.paths.createPath); };
        }
      }
    }
    else if (actionItem.groupcategory === 1) {
      // label = this.props.contractTemplate.availableActionTypesTypeDisplayObj[actionItem.actiontype];
      // if (label.startsWith("[M]")) {
      //   label = label.slice(3);
      // }
      label = globalResources["ACTION_TYPE_" + actionItem.actiontype] ?? label;
      onClickFunc = this.onClickComplete.bind(this, actionItem);
    }
    return (
      <div key={actionItem.actionid} className="kt-timeline-v2__item" >
        <span className="kt-timeline-v2__item-time">{formattedDate}</span>
        <div className="kt-timeline-v2__item-cricle">
          <i className={"fa fa-genderless " + "kt-font-" + badgeColor} />
        </div>
        <div className="kt-timeline-v2__item-text kt-padding-top-5">
          <div className="kt-timeline-v2__info">
            <span className="kt-timeline-v2__desc" style={spanStyleViewRegister}><a onClick={onClickFunc} style={{ textDecoration: 'underline', fontSize: '1.1rem', paddingTop: '0.5rem' }}>{label}</a></span>
          </div>
        </div>
      </div>
    );
  }
  onClickComplete = async (actionItem, e) => {
    e.preventDefault();
    let result = await completeActionConfirmationDialog(actionItem, this.props.intl);
    if (result) {
      try {
        const requestObj = {
          contractid: this.props.contract.contractid,
          actionids: [actionItem.actionid]
        }
        const response = await actionCrud.complete(requestObj);
        this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: "GENERAL.ACTION_COMPLETED" }), { variant: "success" });
        this.setNewState();
      } catch (err) {
        this.props.enqueueSnackbar(err.toString(), { variant: "error" });
      }
    }
  }

  render() {
    const { resources: globalResources } = this.props.contractTemplate;
    return (
      <>

        <div className="kt-widget14" style={{ display: "flex", height: "100%", flexDirection: "column" }}>
          <div className="kt-widget14__header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <h3 className="kt-widget14__title">
              {this.props.title ? this.props.title :
                (
                  <FormattedMessage id={"CONTRACT.DASHBOARD.CONTRACT_RECENT_PAYMENTS"} />
                )
              }

            </h3>
          </div>
          {
            (this.state.actions?.items?.length > 0) && (
              <div className="kt-timeline-v2 ">
                <div className="kt-timeline-v2__items kt-padding-top-25 kt-padding-bottom-30">
                  {
                    this.state.actions?.items?.map((itm, index) => {
                      return this.getDate(itm);
                    })
                  }

                </div>
              </div>
            )
          }

          {!(this.state.actions?.items?.length > 0) && (
            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1 }}>
              <span style={{ fontFamily: SystemHelper.getThemeTextFont(), fontSize: '1.1rem', color: '#74788d', textAlign: 'center' }}>{this.props.intl.formatMessage({ id: 'GENERAL.WARNING.NO_ITEM_AVAILABLE' }, { ITEM_NAME: this.props.intl.formatMessage({ id: 'CONTRACT.DASHBOARD.CONTRACT_RECENT_PAYMENTS' }) })}</span>
            </div>
          )}
        </div>

      </>
    );
  }
}

export default injectIntl(withSnackbar(withRouter(ContractNextPayment)));
